import axios from "axios";

export default function PartneraddressTypeService(partnerId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/partnerAddress/" + partnerId + "/addressType",
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
